import { deserializeHostingElementFromUrl } from '../services/urlGeneratorService';
import { DEFAULT_HOSTING_ELEMENT_ID } from '../constants/enums';

var KAMPYLE_DATA,
  KAMPYLE_UTILS,
  KAMPYLE_CONSTANT,
  KAMPYLE_ONSITE_SDK,
  KAMPYLE_EVENT_DISPATCHER,
  KAMPYLE_FUNC,
  close;

function getTriggerTypeByFormType(eventName) {
  var eventTriggerMapping = {
    button: 'Button',
    code: 'ByCode',
    invitation: 'Invitation',
    embedded: 'Embedded',
  };

  return eventTriggerMapping[eventName] || null;
}

export function onScriptLoaded(contextWindow) {
  console.log('onScriptLoaded');
  KAMPYLE_DATA = contextWindow.KAMPYLE_DATA;
  KAMPYLE_UTILS = contextWindow.KAMPYLE_UTILS;
  KAMPYLE_CONSTANT = contextWindow.KAMPYLE_CONSTANT;
  KAMPYLE_ONSITE_SDK = contextWindow.KAMPYLE_ONSITE_SDK;
  KAMPYLE_EVENT_DISPATCHER = contextWindow.KAMPYLE_EVENT_DISPATCHER;
  KAMPYLE_FUNC = contextWindow.KAMPYLE_FUNC;
  close = window.close;
  registerToModalClosedErr();
}

function mockEmbed(contextWindow) {
  contextWindow.MDIGITAL = {
    nebContext: 'preview'
  }
  contextWindow.KAMPYLE_EMBED = {
    getResourcesPrefix: function() {
      var urlPrefix = KAMPYLE_CONSTANT.PLACEHOLDERS.URL_PREFIX;
      return urlPrefix.substring(0, urlPrefix.length - 1);
    }
  }
}

export function createSimulationIframeContainer() {
  return new Promise((resolve) => {
    const iframe = document.createElement('iframe');
    iframe.src = '/dig-preview/build/mobile_iframe.html' + location.search;
    iframe.onload = () => {
      mockEmbed(iframe.contentWindow);
      resolve(iframe.contentWindow);
    };
    document.getElementById('md-iframe-container').appendChild(iframe);
  });
}

export function injectOnsiteScriptIntoContext(contextWindow, propertyId, formUuid, versionToPresent, isDraft) {
  const contextDoc = contextWindow.document;
  const scriptElement = Object.assign(contextDoc.createElement('script'), {
    src: getOnsiteScriptURL(propertyId, formUuid, versionToPresent, isDraft)
  });
  contextDoc.head.appendChild(scriptElement);
}

export function loadOnsiteScript(propertyId, formUuid, versionToPresent, isDraft) {
  mockEmbed(window);
  const scriptElement = Object.assign(document.createElement('script'), {
    src: getOnsiteScriptURL(propertyId, formUuid, versionToPresent, isDraft)
  });
  document.body.appendChild(scriptElement);
}

function registerToModalClosedErr(){
  window.addEventListener('MD_errorModalClosed', function(e){
    window.close();
  });
}

export function getOnsiteScriptURL(propertyId= '-1', formUUID, version = 'V1', isDraft) {
  const prefix = '/kma/api/forms-preview/property/';
  const mode = isDraft ? 'drafts/' : 'forms/';
  const infix = `${propertyId}/${mode}${formUUID}/`;
  const suffix = 'script';
  const versionQueryParam = `?versionToPresent=${version}`;
  return prefix + infix + suffix + versionQueryParam;
}

export function getCustomParams() {
  if (!KAMPYLE_DATA) {
    return [];
  }
  const formId = getFormId();
  const isEncapsulation = KAMPYLE_FUNC.checkProvision('23dcr3_MPC4831_enableEncapsulation');
  const allCP = isEncapsulation && KAMPYLE_DATA.getMemory().dataJson.customParams || [];
  const formCP = KAMPYLE_DATA.getFormData(formId).customParams || [];
  const customParams = !isEncapsulation ? formCP : formCP.reduce((acc, formCpId) => {
      const cp = allCP.find(cp => cp.id === formCpId);
      if (cp) acc.push(cp);
      return acc;
  }, []);
  return customParams.map(cp => {
    const { id, source, source_name, type, unique_name } = cp;
    return {
      id,
      name: unique_name,
      type,
      source,
      sourceName: source_name,
      value: null,
    };
  });
}

function setModalSize() {
  let kampyleFormModelElement = document.getElementById("kampyleFormContainer");

  if (kampyleFormModelElement) {
    kampyleFormModelElement.style.backgroundColor = "transparent";
    kampyleFormModelElement.style.zIndex = "99999998";
  }
}

export function getFormId() {
  if (!KAMPYLE_DATA) {
    return false;
  }
  return KAMPYLE_DATA.getAllForms()[0].formId;
}

export function isEmbeddedForm (formId =  0) {
  if (!KAMPYLE_DATA) {    
    return false;
  }  
  return KAMPYLE_DATA.isEmbeddedDisplayType(formId);  
}

export function getHostingElementProps() {
  const newProps = {
    width: '',
    minHeight:'',
    maxHeight:''
  };
  const hostingObj = deserializeHostingElementFromUrl();
  for (let prop in hostingObj) {
    if (hostingObj.hasOwnProperty(prop) && parseInt(hostingObj[prop], 10)) {
      newProps[prop] = parseInt(hostingObj[prop], 10);
    } else {
      newProps[prop] = '';
    }
  }
  return newProps;
}

export function setHostingElementDimensions(hostingElement) { 
  if (!hostingElement) {
    return false;
  }
  let hostingElementObj = getHostingElementProps();

  hostingElement.style.width = isNaN(hostingElementObj.width)? hostingElement.style.width : hostingElementObj.width+'px';
  hostingElement.style.minHeight = isNaN(hostingElementObj.minHeight)? hostingElement.style.minHeight : hostingElementObj.minHeight+'px';
  hostingElement.style.maxHeight = isNaN(hostingElementObj.maxHeight)? hostingElement.style.maxHeight : hostingElementObj.maxHeight+'px';
}

export function getHostingElementId() {  
  if (!KAMPYLE_DATA) { 
    return '';
  }
  const formData = KAMPYLE_DATA.getFormData(getFormId());
  if (!formData || !formData.embeddedData) {
    return DEFAULT_HOSTING_ELEMENT_ID;
  }
  
  return formData.embeddedData.pageElementId || DEFAULT_HOSTING_ELEMENT_ID;
}

export function setHostingElementForMobile (contextWindow) {
  const hostingElementId = getHostingElementId();
  const el = contextWindow.document.createElement('div');
  el.id = hostingElementId;
  contextWindow.document.body.appendChild(el);
  setHostingElementDimensions(el);
}

export function setHostingElementProps (formId = 0) {
  if (!isEmbeddedForm(formId)) {
    return false;
  }
  const hostingElementId = getHostingElementId();

  const hostingElement =  document.getElementById(hostingElementId);
  setHostingElementDimensions(hostingElement); 
}

export function showForm(contextWindow, formId = 0, propertyType, isDraft = false) {
  console.log('showForm');  
  const formData = KAMPYLE_DATA.getFormData(formId); 
  if (!isEmbeddedForm(formId)) {   
    KAMPYLE_UTILS.setNestedPropertyValue(formData, 'formDisplay.displayType', KAMPYLE_CONSTANT.DISPLAY_TYPES.LIGHTBOX);
  } else {    
    KAMPYLE_UTILS.setNestedPropertyValue(formData, 'embeddedData.pageElementId', getHostingElementId());
  }

  KAMPYLE_ONSITE_SDK.showForm(formId, {
    context: `${isDraft ? 'DraftPreview' : 'Preview'}`,
    triggerType: getTriggerTypeByFormType(formData.formType),
  });
  KAMPYLE_EVENT_DISPATCHER.subscribe('neb_formClosed', close);
  KAMPYLE_EVENT_DISPATCHER.subscribe('neb_formLoaded', setModalSize);
  KAMPYLE_UTILS.setEventHandler(contextWindow, 'resize', () => setTimeout(setModalSize));
  setBackground(contextWindow.document, propertyType);
}

export function checkProvision(provisionName) {
  if (!KAMPYLE_FUNC) {
    return false;
  }
  return KAMPYLE_FUNC.checkProvision(provisionName);
}

export function getProvisions() {
  if (!KAMPYLE_FUNC) {
    return [];
  }
  return KAMPYLE_FUNC.getAllProvisions();
}

function setBackground(contextDoc, propertyType) {
  const spanElement = contextDoc.querySelector('body>span');
  if (!spanElement) {
    console.log('Cannot set background - span element not found');
    return;
  }
  spanElement.setAttribute('neb-property-type', propertyType);
}